import React, { Component } from "react";
import _ from "i18n";
import { SubMenuLink } from "../../SubMenuLink";
export default class Dashboard extends Component {
  render() {
    return <SubMenuLink pathname="/dashboard" title={"Dashboard"} icon="DASHBOARD_LIGHT" />;
  }
}
